<div class="btn-group me-2">
  <button class="btn btn-primary" type="button" (click)="changePage(-1)" [disabled]="page <= 0 || isLoading">
    <i class="fa fa-chevron-left"></i>
  </button>
  <button class="btn btn-outline-primary" type="button" disabled>
    Page: {{page + 1}}/{{math.floor(count / perPage + 1)}}
  </button>
  <button class="btn btn-primary" type="button" (click)="changePage(1)" [disabled]="(count - (perPage * page)) <= perPage || isLoading">
    <i class="fa fa-chevron-right"></i>
  </button>
</div>